import { Component, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-agb-handwerker',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './agb-handwerker.component.html',
})
export class AgbHandwerkerComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'AGB für Handwerker · Craftly',
      description: 'Allgemeine Geschäftsbedingungen für Handwerker auf der Craftly-Plattform.',
      path: '/agb/handwerker',
      type: 'article',
    });
  }
}
